import { forwardRef } from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

/**
 * An icon-only action in the ticket header (Figma Tertiary Button, 1085:55654): a 28px circle with no
 * border or fill until hover, named for screen readers and in a dark tooltip (Figma 1085:55558). Forwards its ref so a popover can use it as its trigger.
 */
export const HeaderIconButton = forwardRef<HTMLButtonElement, React.ComponentProps<'button'> & { label: string }>(
  function HeaderIconButton({ label, className, children, ...props }, ref) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            ref={ref}
            type="button"
            aria-label={label}
            className={cn(
              'flex size-7 shrink-0 items-center justify-center rounded-full text-text-body transition-colors hover:bg-gray-100',
              'focus-visible:outline-2 focus-visible:outline-ring disabled:opacity-60',
              className,
            )}
            {...props}
          >
            {children}
          </button>
        </TooltipTrigger>
        <TooltipContent variant="dark">{label}</TooltipContent>
      </Tooltip>
    );
  },
);
